import can from 'can';
import $ from 'jquery';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

import {BaseCloudinaryModule} from '../../js/usga.base-module';
import {Tabs} from '../tabs/tabs';
import {usgaUtils} from '../../js/usga.utils';

export const LeaderBoardBaseControl = BaseCloudinaryModule.extend({
    initialized: false,
    defaultSortDirection: 'asc',
    defaultSortType: 'number-t',
    currentSortDirection: 'asc',
    currentSortType: 'number-t',
    updateInterval: null,
    updateIntervalDuration: 3e4,
    tickerUpdateIntervalDuration: 3e4,
    miniLeaderboardUpdateIntervalDuration: 12e4,
    scoringUpdateIntervalDuration: 3e4,
    fourballUpdateIntervalDuration: 6e4,
    openUpdateIntervalDuration: 3e4,
    amateurStrokeplayUpdateIntervalDuration: 3e4,
    amateurMatchplayUpdateIntervalDuration: 3e4, // 12e4,
    cupUpdateIntervalDuration: 12e4,
    stateUpdateIntervalDuration: 6e4,
    partialsUpdateTimeout: 100,
    changedData: [],
    dataUrl: null,
    init: function () {
        this._super();
        this.initUpdateDuration();
    },
    initUpdateDuration: function () {
    },
    setUpdateDurationRegardingToEventType: function () {
        if (this.context.attr('isCupChampionship')) {
            this.updateIntervalDuration = this.cupUpdateIntervalDuration;
        }
        if (this.context.attr('isStateChampionship')) {
            this.updateIntervalDuration = this.stateUpdateIntervalDuration;
        }
        if (this.context.attr('isFourballChampionship')) {
            this.updateIntervalDuration = this.fourballUpdateIntervalDuration;
        }
        if (this.context.attr('isOpenChampionship')) {
            this.updateIntervalDuration = this.openUpdateIntervalDuration;
        }
        if (this.context.attr('isAmateurMatchPlayLb')) {
            this.updateIntervalDuration = this.amateurMatchplayUpdateIntervalDuration;
        }
        if (this.context.attr('isAmateurIntlStrokeLb') || this.context.attr('isAmateurIntlStrokeLb')) {
            this.updateIntervalDuration = this.amateurStrokeplayUpdateIntervalDuration;
        }
    },
    destroy: function () {
        if (this.updateInterval) {
            window.clearInterval(this.updateInterval);
        }
        can.Control.prototype.destroy.call(this);
    },
    getData: function () {
        can.ajax({
            type: 'GET',
            url: this.dataUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            success: this.proxy(function (data) {
                if (data && typeof (data) === 'object') {
                    if (!this.initialized) {
                        this.initialized = true;
                        this.applyInitialContextData(data);
                    } else {
                        this.applyDataChanges(data);
                    }
                } else {
                    this.handleError();
                }
            }),
            error: this.proxy(function (xhr) {
                this.handleError(xhr);
            })
        });
    },
    handleError: function (xhr) {
        console.log(xhr);
    },
    initCustomSelect: function () {
        this.$element.find('.header-box__list-dropdown .dropdown').chosen({
            disable_search_threshold: 10,
            width: '100%'
        });
    },
    getHelpers: function () {
        var context = this.context;
        return {
            isCurrentRound: function (roundNumber, options) {
                roundNumber = can.isFunction(roundNumber) ? roundNumber() : roundNumber;
                return roundNumber == context.attr('currentRound') ? options.fn() : options.inverse();
            },
            isTwoRoundsEvent: function (roundData, options) {
                roundData = can.isFunction(roundData) ? roundData() : roundData;
                if (roundData.attr('length') == 2) {
                    return options.fn(this);
                }
                return options.inverse(this);
            },
            isEqual: function (value1, value2, options) {
                value1 = can.isFunction(value1) ? value1() : value1();
                if (value1 == value2) {
                    return options.fn(this);
                }
                return options.inverse(this);
            }
        };
    },
    getLegends: function (data) {
        if (data) {
            var legendsData = data.legend;
            var legends = [];
            if (can.isArray(legendsData)) {
                for (var i = 0, ii = legendsData.length; i < ii; i++) {
                    legends.push(legendsData[i].text);
                }
            } else {
                legends.push(legendsData.text);
            }
            return legends;
        } else {
            return null;
        }
    },
    initDataUpdating: function () {
        if (this.updateInterval) {
            window.clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
        this.updateInterval = window.setInterval(this.proxy(function () {
            this.getData();
            this._onDataUpdated();
        }), this.updateIntervalDuration);
    },
    _onDataUpdated: function () {
        if (this.onDataUpdated) {
            this.onDataUpdated();
        }
        if (this.updateInterval !== null) {
            if (Tabs) {
                Tabs.getTickerData().done(this.proxy(function (data) {
                    var now = usgaUtils.getMomentInNewYorkTimezone().valueOf(),
                        startDate = usgaUtils.getMomentInNewYorkTimezone(data.startDate).valueOf(),
                        endDate = usgaUtils.getMomentInNewYorkTimezone(data.endDate).valueOf();

                    if ((startDate <= now && now < endDate) === false) {
                        this.stopUpdateInterval();
                    }
                }));
            }
        }
    },
    stopUpdateInterval: function () {
        if (this.updateInterval !== null) {
            window.clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    },
    applyPartialData: function (list, start, chunk, callback) {
        var self = this;
        var part;
        if (can.isArray(list)) {
            part = list.slice(start, start + chunk);
        } else {
            part = [];
            part.push(list);
        }
        can.batch.start(function () {
            window.setTimeout(function () {
                var nextStart = start + chunk;
                if (nextStart < list.length) {
                    self.applyPartialData(list, nextStart, chunk, callback);
                } else {
                    self.initDataUpdating();
                }
            }, this.partialsUpdateTimeout);
        });
        if (callback) {
            callback(part);
        }
        can.batch.stop();
    },
    compareAndSetAttr: function (changedValue, modelValue, model, attr) {
        if (typeof changedValue !== 'object') {
            if (changedValue != modelValue && model && attr) {
                model.attr(attr, changedValue);
                this.hasChanges = true;
            }
        } else if (can.isArray(changedValue)) {
            if (modelValue instanceof can.List) {
                for (var i = 0, ii = changedValue.length; i < ii; i++) {
                    if (modelValue.attr(i)) {
                        this.compareAndSetAttr(changedValue[i], modelValue.attr(i), modelValue, i);
                    } else {
                        modelValue.push(changedValue[i]);
                    }
                }
            } else {
                model.attr(attr, changedValue);
            }
        } else {
            if (modelValue !== null && modelValue !== undefined && modelValue !== '') {
                for (var a in changedValue) {
                    if (changedValue.hasOwnProperty(a)) {
                        this.compareAndSetAttr(changedValue[a], modelValue.attr(a), modelValue, a);
                    }
                }
            } else {
                model.attr(attr, changedValue);
            }
        }
        return this.hasChanges;
    },
    sortDomElements: function (attr, direction, type, elementClass, appendClass) {
        var domElements = this.$element.find('.' + elementClass);
        var cutLine = this.$element.find('.' + elementClass + '.' + appendClass + '-cut-line');

        if (cutLine) {
            var aboveCutLineElements = [];
            var aboveCutLine = true;
            var underCutLineElements = [];
            domElements.each(function (i, el) {
                if ($(el).hasClass(elementClass + ' ' + appendClass + '-cut-line')) {
                    aboveCutLine = false;
                    return true;
                }

                if (aboveCutLine) {
                    aboveCutLineElements.push(el);
                } else {
                    underCutLineElements.push(el);
                }
            });
            aboveCutLineElements.sort(this.setSortingArgument(attr, direction, type, true));
            aboveCutLineElements.forEach(function (el, index) {
                can.$(el).detach().insertAfter(can.$('.' + appendClass).last());
            });
            underCutLineElements.sort(this.setSortingArgument(attr, direction, type, true));
            underCutLineElements.forEach(function (el, index) {
                can.$(el).detach().insertAfter(can.$('.' + appendClass).last());
            });
        } else {
            domElements.sort(this.setSortingArgument(attr, direction, type, true));
            domElements.each(function () {
                can.$(this).detach().insertAfter(can.$('.' + appendClass).last());
            });
        }
    },
    sortList: function (list, attr, direction, type) {
        this.currentSortAttr = attr;
        this.currentSortDirection = direction;
        this.currentSortType = type;
        list.sort(this.setSortingArgument(attr, direction, type));
    },
    setSortingArgument: function (attr, direction, type, isDomElement) {
        var self = this;
        return function (a, b) {
            var firstVal, secondVal;
            if (isDomElement) {
                firstVal = can.$(a).data(attr);
                secondVal = can.$(b).data(attr);
            } else {
                firstVal = typeof a[attr] === 'function' ? a[attr]() : a[attr];
                secondVal = typeof b[attr] === 'function' ? b[attr]() : b[attr];
            }
            firstVal = self.parseSortingData(firstVal, direction, type);
            secondVal = self.parseSortingData(secondVal, direction, type);

            if (firstVal == '') {
                return 1;
            } else if (secondVal == '') {
                return -1;
            } else {
                if (firstVal === secondVal) {
                    if (isDomElement) {
                        firstVal = can.$(a).data('list-index');
                        secondVal = can.$(b).data('list-index');
                    }
                }
                if (direction == 'asc') {
                    return firstVal === secondVal ? 0 : firstVal < secondVal ? -1 : 1;
                } else {
                    return firstVal === secondVal ? 0 : firstVal > secondVal ? -1 : 1;
                }
            }
        };
    },
    parseSortingData: function (val, direction, type) {
        var sortingMax = 1e5;
        var fValue = 1e7;
        var dqValue = sortingMax + 1;
        var mcValue = sortingMax + 2;
        var wdValue = sortingMax + 3;
        var spaceValue = sortingMax;
        var dashValue = sortingMax + 5;

        if (val === '' || /^\s*$/.test(val) || val === undefined) {
            return '';
        } else {
            if (type == 'number' || type == 'number-nan' || type == 'number-t') {
                if (typeof val === 'string') {
                    val = val.replace(/t/i, '')
                        .replace(/mc/i, mcValue)
                        .replace(/wd/i, wdValue)
                        .replace(/dq/i, dqValue);
                }
                if (val === '' || /^\s*$/.test(val) || val === undefined) {
                    val = spaceValue;
                } else if (val == '-') {
                    val = direction == 'asc' ? dashValue : -dashValue;
                } else if (val == 'e' || val == 'E') {
                    val = 0;
                } else {
                    val = typeof val === 'number' ? val : parseInt(val);
                }
            } else if (type == 'float') {
                val = typeof val === 'number' ? val : parseFloat(val);
            } else if (type == 'thru') {
                if (/^[0-9]{1,2}\:[0-9]{1,2}/i.test(val)) {
                    val = val.replace(/p\.m\./i, 'pm').replace(/a\.m\./i, 'am').replace(/\*/i, '');
                    val = sortingMax - this.parseTimeForSorting(val);
                } else if (/f\*?/i.test(val)) {
                    val = fValue;
                } else if (val === ' ' || val === '') {
                    val = 0;
                } else {
                    val = parseInt(val) + sortingMax;
                }
            } else if (type == 'time') {
                val = this.parseTimeForSorting(val);
            }
        }

        return val;
    },
    parseTimeForSorting: function (val) {
        var timeIncrement = 1200;
        var timeRegExp = /([0-9]{1,2})\:([0-9]{1,2})\s*p?a?m/i;
        val = val.replace(/^12:/i, '0:');
        if (/pm$/i.test(val)) {
            val = val.replace(timeRegExp, '$1$2');
            val = parseInt(val) + timeIncrement;
        } else {
            val = val.replace(timeRegExp, '$1$2');
            val = parseInt(val);
        }
        return val;
    },
    setSortType: function (element, attr, type, data, headers) {
        if (data === null) {
            data = [];
        }
        if (element.hasClass('sort-asc')) {
            element.removeClass('sort-asc');
            element.addClass('sort-desc');
            this.sortList(data, attr, 'desc', type);
            this.sortTables(attr, 'desc', type);
        } else if (element.hasClass('sort-desc')) {
            element.removeClass('sort-desc');
            element.addClass('sort-asc');
            this.sortList(data, attr, 'asc', type);
            this.sortTables(attr, 'asc', type);
        } else {
            headers.removeClass('sort-asc').removeClass('sort-desc');
            element.addClass('sort-asc');
            this.sortList(data, attr, 'asc', type);
            this.sortTables(attr, 'asc', type);
        }
    },
    createScorecardDrawer: function (element, model) {
        var playerDrawer;
        var drawerWrap = can.$('<tr class="attached-drawer"><td colspan="12" id="drawer' + model.attr('idField') + '"></td></tr>');
        element.after(drawerWrap);
        if (model.attr('isFourBallIntlStrokeLb') || model.attr('isAmateurIntlStrokeLb')) {
            playerDrawer = new usga.LeaderboardDrawerScorecardFourball('#drawer' + model.attr('idField'), model);
        } else {
            playerDrawer = new usga.LeaderboardDrawerScorecard('#drawer' + model.attr('idField'), model);
        }
        usga.trackDtm('scorecard-click');
    },
    createMatchPlayDrawer: function (element, model) {
        var drawerWrap = can.$('<div id="drawer' + model.attr('idField') + '" class="lb-match__container__item__drawer attached-drawer"></div>');
        element.after(drawerWrap);
        var matchDrawer = new usga.LeaderboardDrawerMatchPlay('#drawer' + model.attr('idField'), model);
        usga.trackDtm('scorecard-click');
    },
    findTableElement: function (value, elements) {
        value = value.replace(/\s/, '\\s*');
        var searchRegExp = new RegExp(value, 'ig');
        var zeroResultRow = $('.starting-times-anchor');
        if (value === '' || !value) {
            elements.show();
            zeroResultRow.hide();
        } else {
            var isEmpty = true;
            elements.each(function () {
                var $element = can.$(this);
                var searchText = $element.data('search') || $element.text();
                if (searchRegExp.test(searchText)) {
                    $element.show();
                    isEmpty = false;
                } else {
                    $element.hide();
                }
            });
            if (isEmpty) {
                zeroResultRow.show();
            }
        }
    },
    applyCourseData: function (list, courseData) {
        if (can.isArray(courseData)) {
            for (var i = 0, ii = courseData.length; i < ii; i++) {
                list.push(courseData[i]);
            }
        } else {
            list.push(courseData);
        }
    },
    getObjByKeyName: function (list, key, value) {
        for (var i = 0, ii = list.length; i < ii; i++) {
            var item = list[i];
            if (item[key] && item[key] == value) {
                return item;
            }
        }
        return null;
    },
    dataToArray: function (data) {
        var outputData = [];
        if (can.isArray(data)) {
            return data;
        } else {
            outputData.push(data);
            return outputData;
        }
    },
    getPlaySuspended: function (data) {
        if (data && data.suspended) {
            if (data.suspended != 'false' && data.suspended != '0') {
                return data.message;
            }
        }
        return null;
    },
    renderSuspended: function (data) {
        var suspended = this.getPlaySuspended(data.event.tournament.playsuspended);
        var template = $('<div class="alert alert_warning"><span class="alert__title">COURSE ALERT:</span>&nbsp;' +
			'<span class="s-text"></span></div>');
        var suspendedElement = this.$element.find('.alert_warning');
        if (suspended) {
            if (!suspendedElement.length) {
                template.find('.s-text').text(suspended);
                this.$element.prepend(template);
            } else {
                suspendedElement.find('.s-text').text(suspended);
                suspendedElement.show();
            }
        } else {
            suspendedElement.hide();
        }
    },
    renderHeader: function () {
        var header = $('<div class="lb-match__cut-line">Match Status</div>');
        this.$element.append(header);
    },
    createProjectedCutlineLink: function (cutData) {
        var linkTemplate = '<br/><a href="javascript:void(0);" class="cutline-link">Projected Cutline Explained</a>';
        if (cutData.attr('cutisprojected') &&
			cutData.attr('cutisprojected') == '1' || cutData.attr('cutisprojected').toLowerCase() == 'true') {
            return linkTemplate;
        }
        return '';
    },
    getItemsByKeyValue: function (data, key, value) {
        var output = [];
        for (var i = 0, ii = data.length; i < ii; i++) {
            var obj = data[i];
            if (obj[key] == value) {
                output.push(obj);
            }
        }
        return output;
    },
    saveToStorage: function (key, value) {
        window.localStorage.setItem(key, value);
    },
    getFromStorage: function (key) {
        return window.localStorage.getItem(key);
    },
    removeFromStorage: function (key) {
        window.localStorage.removeItem(key);
    },
    recalculateDropdown: function (additionalItemsWidth) {
        var that = this;
        var moreItem = $('.dropdown.tabdrop');

        var additionalWidth = additionalItemsWidth || 0;

        var navigationWidth = $('.header-box__list').width() - additionalWidth;
        var moreItemWidth = moreItem.outerWidth(true);
        var itemsNumber = this.navItemsMap.length;
        var menuItemsWidth = 0;
        var isFit = true;

        this.navItemsMap.forEach(function (el, index) {
            if (isFit) {
                var itemWidth = $(el).outerWidth(true);
                if (menuItemsWidth + itemWidth + (index === itemsNumber - 1 ? 0 : moreItemWidth) <= navigationWidth) {
                    $(el).removeClass('is-hidden');
                    $(that.navMoreItemsMap[index]).addClass('is-hidden');
                    menuItemsWidth += itemWidth;
                } else {
                    $(el).addClass('is-hidden');
                    $(that.navMoreItemsMap[index]).removeClass('is-hidden');
                    isFit = false;
                }
            } else {
                $(el).addClass('is-hidden');
                $(that.navMoreItemsMap[index]).removeClass('is-hidden');
            }
        });
        moreItem.toggleClass('is-hidden', isFit);
    },
    findTZByAbbr: function (tokens) {
        var zones = dayjs.tz._zones;
        for (var zonesKey in zones) {
            if (zones.hasOwnProperty(zonesKey)) {
                var zone = zones[zonesKey];
                if (typeof zone === 'string') {
                    zone = dayjs.tz.unpack(zone);
                }
                for (var i = 0; i < tokens.length; i++) {
                    var abbr = tokens[i];
                    if (zone.abbrs.indexOf(abbr) >= 0) {
                        return zone.name;
                    }
                }
            }
        }
    },
    findTimezone: function (event) {
        var timeTokens = (event.timezone || event.localtime).split(' ').reverse();
        var zone = this.findTZByAbbr(timeTokens);
        if (zone) {
            this.context.attr('timezone', zone);
        }
        this.context.attr('localTimezone', dayjs.tz.guess());
    }
});
